import { useState } from 'react';
import { DropDownMenu } from '../../../shared/common/DropDownMenu';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

interface Props<T> {
    currentSorting: T;
    setCurrentSorting: (sortBy: T) => void;
    availableSortingValues: T[];
}

export function CopyDetailsSortBy<T extends { key: string; label: string }>({
    currentSorting,
    setCurrentSorting,
    availableSortingValues
}: Props<T>) {
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(false);

    return (
        <DropDownMenu
            expanded={expanded}
            onToggleClick={() => setExpanded(!expanded)}
            onClickOutside={() => setExpanded(false)}
            align="right"
            className="fl-right dd-a-r cc-sortby"
            btnInnerClassName="bt-inner"
            arrowClassName="up arrow fl-right"
            label={t(`components.sortByDropdown.${currentSorting.key}`, { defaultValue: currentSorting.label })}
            iconCode="&#xE164;"
        >
            {availableSortingValues.map(sortBy => {
                const isActive = sortBy.key === currentSorting.key;

                return (
                    <li key={sortBy.key}>
                        <a
                            className={classNames({ checked: isActive })}
                            onClick={() => {
                                setCurrentSorting(sortBy);
                                setExpanded(false);
                            }}
                        >
                            {t(`components.sortByDropdown.${sortBy.key}`, { defaultValue: sortBy.label })}
                            {isActive ? <i className="material-icons">check</i> : null}
                        </a>
                    </li>
                );
            })}
        </DropDownMenu>
    );
}
